export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[520px] md:min-h-[600px] flex items-center pt-[64px] md:pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-background-100">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-10 left-10 w-72 h-72 rounded-full bg-primary-500/30 blur-3xl"></div>
          <div className="absolute bottom-10 right-20 w-96 h-96 rounded-full bg-accent-500/20 blur-3xl"></div>
          <div className="absolute top-1/2 left-1/3 w-64 h-64 rounded-full bg-secondary-500/15 blur-3xl"></div>
        </div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="flex flex-wrap justify-center lg:justify-start gap-2 mb-4">
              <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-accent-500/15 text-accent-400 text-xs font-medium whitespace-nowrap">
                <i className="ri-fire-fill text-xs"></i>
                每日更新
              </span>
              <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-secondary-500/15 text-secondary-400 text-xs font-medium whitespace-nowrap">
                <i className="ri-flashlight-fill text-xs"></i>
                高清不卡
              </span>
              <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-primary-500/15 text-primary-400 text-xs font-medium whitespace-nowrap">
                <i className="ri-vip-crown-fill text-xs"></i>
                完全免费
              </span>
            </div>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-black text-foreground-50 leading-tight mb-3">
              四虎影视大全
              <span className="block text-primary-500 text-xl md:text-3xl lg:text-4xl mt-1">
                高清免费在线观影平台
              </span>
            </h1>

            <p className="text-foreground-500 text-sm md:text-base leading-relaxed mb-4 max-w-xl mx-auto lg:mx-0">
              您的随身高清影院，畅享无限精彩
            </p>

            <p className="text-foreground-400 text-sm md:text-base leading-relaxed mb-6 max-w-xl mx-auto lg:mx-0">
              四虎影视大全汇聚海量电视剧、电影、综艺、动漫资源，每日同步更新最新内容。高清画质搭配智能加速技术，无需等待缓冲，打开即看。全平台免费在线观看，无需注册、
              无需付费，随时随地畅享流畅观影体验。当前热播剧场涵盖国产剧、日韩剧、欧美大片及经典老片，满足全家人的观影需求。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-primary-500/15 flex items-center justify-center">
                  <i className="ri-movie-line text-primary-400 text-sm"></i>
                </div>
                <div className="text-left">
                  <div className="text-foreground-200 font-bold text-sm">10万+</div>
                  <div className="text-foreground-600 text-xs">影视资源</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-accent-500/15 flex items-center justify-center">
                  <i className="ri-user-heart-line text-accent-400 text-sm"></i>
                </div>
                <div className="text-left">
                  <div className="text-foreground-200 font-bold text-sm">每日更新</div>
                  <div className="text-foreground-600 text-xs">片源不断</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-secondary-500/15 flex items-center justify-center">
                  <i className="ri-shield-check-line text-secondary-400 text-sm"></i>
                </div>
                <div className="text-left">
                  <div className="text-foreground-200 font-bold text-sm">安全稳定</div>
                  <div className="text-foreground-600 text-xs">流畅不卡</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-foreground-50 font-semibold rounded-full text-sm whitespace-nowrap transition-all cursor-pointer"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                立即观影
              </a>
              <a
                href="#features"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-200/70 hover:bg-background-300/70 text-foreground-300 font-medium rounded-full text-sm whitespace-nowrap transition-all cursor-pointer border border-background-300/50"
              >
                <i className="ri-information-line text-lg"></i>
                了解平台
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-200/50">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20movie%20theater%20atmosphere%20with%20warm%20golden%20and%20amber%20lighting%2C%20film%20reel%20elements%20floating%20in%20abstract%20space%2C%20dramatic%20spotlight%20rays%20cutting%20through%20darkness%2C%20luxurious%20velvet%20curtain%20texture%2C%20elegant%20and%20artistic%20cinema%20visual%20with%20deep%20blacks%20and%20warm%20highlights%2C%20no%20text%2C%20abstract%20cinematic%20composition&width=960&height=720&seq=hero-movie-01&orientation=landscape"
                alt="四虎影视大全 - 高清免费在线观影平台主视觉"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/60 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}